export default "__VITE_ASSET__Dm00kPTp__"